import { realBricksApi } from '../../utils/axiosInterceptors';

export const logOutUser = async () => {
  const response = await realBricksApi.post(`/api/v1/logout`);
  return response.data;
};
